import { C } from "./theme";

export const Btn = ({ ch, v = "pri", s = "md", onClick, sx, ...r }) => {
  const base = {
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    gap: 8, borderRadius: 10, fontWeight: 600, transition: "all .2s", border: "none",
    padding: s === "sm" ? "9px 18px" : s === "lg" ? "14px 32px" : "11px 24px",
    fontSize: s === "sm" ? 14 : s === "lg" ? 16 : 15,
  };
  const vs = {
    pri: { background: C.pri, color: C.wh },
    out: { background: "transparent", color: C.pri, border: `1.5px solid ${C.pri}` },
    gh: { background: C.priPl, color: C.pri },
    wh: { background: C.wh, color: C.pri, boxShadow: "0 2px 8px rgba(0,0,0,.08)" },
  };
  return <button onClick={onClick} style={{ ...base, ...vs[v], ...sx }} {...r}>{ch}</button>;
};
